import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminPedido: Routes = [
  {
    path: 'pedidos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'PEDIDOS',
      menuKey: 'PEDIDOS',
      breadcrumb: {
        label: 'Pedidos',
        icon: 'pi pi-fw pi-shopping-cart'
      },
      backend_path: '/pedidos'
    },
    loadChildren: () =>
      import('@app/modules/pedidos/pedidos.module').then(m => m.PedidoModule)
  }
];
